import * as React from "react"

import { cn } from "@/lib/utils"

export interface InputProps extends React.ComponentProps<"input"> {
  isValid?: boolean;
  isInvalid?: boolean;
  isValidating?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, isValid, isInvalid, isValidating, ...props }, ref) => {
    return (
      <div className="relative">
        <input
          type={type}
          className={cn(
            "flex h-8 w-full rounded-[5px] border bg-background px-3 py-1.5 text-[13px] ring-offset-background file:border-0 file:bg-transparent file:text-[11px] file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 transition-colors duration-fast hover:border-muted-foreground/30",
            isValid && "border-success focus-visible:ring-success",
            isInvalid && "border-destructive focus-visible:ring-destructive animate-shake",
            !isValid && !isInvalid && "border-input",
            className
          )}
          ref={ref}
          {...props}
        />
        {isValid && (
          <svg className="absolute right-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-success" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        )}
        {isInvalid && (
          <svg className="absolute right-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-destructive" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        )}
        {isValidating && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2">
            <div className="w-3.5 h-3.5 border-2 border-border border-t-foreground rounded-full animate-spin" />
          </div>
        )}
      </div>
    )
  }
)
Input.displayName = "Input"

export { Input }
